import { Channel } from "@/controllers/channel/schema";

import { createStore } from "zustand/vanilla";

export type BubblesState = {
  channels: Map<string, Channel>;
  activeBubble: Channel | null;
};

export type BubbleActions = {
   
  addBubble: (Channel: Channel) => void;
   
  removeBubble: (Channel: Channel) => void;
  clearBubbles: () => void;
   
  setActiveBubble: (Channel: Channel | null) => void;
};

export type BubblesStore = BubblesState & BubbleActions;

export function initBubblesStore(): BubblesState {
  return {
    channels: new Map(),
    activeBubble: null,
  };
}

export const defaultInitState: BubblesState = {
  channels: new Map(),
  activeBubble: null,
};

export const createBubblesStore = (
  initState: BubblesState = defaultInitState,
) => {
  return createStore<BubblesStore>()((set, get) => ({
    ...initState,
    addBubble: (channel: Channel) => {
      set(() => {
        const newChannels = new Map();
        newChannels.set(channel.id, channel);
        return { channels: newChannels, activeBubble: null };
      });
    },
    removeBubble: (channel: Channel) => {
      set((state) => {
        const newChannels = new Map(state.channels);
        newChannels.delete(channel.id);

        if (state.activeBubble?.id === channel.id) {
          return { channels: newChannels, activeBubble: null };
        }

        return { channels: newChannels };
      });
    },
    clearBubbles: () => {
      set(() => {
        return { channels: new Map() };
      });
    },
    setActiveBubble: (channel: Channel | null) => {
      const channels = get().channels;
      if (channel && !channels.has(channel.id)) {
        const newChannels = new Map(channels);

        set(() => {
          newChannels.set(channel.id, channel);
          return { channels: newChannels, activeBubble: channel };
        });
      } else {
        set(() => {
          return { activeBubble: channel };
        });
      }
    },
  }));
};
